<section id="why-us" class="clearfix">
  <div class="container">

    <header class="section-header">
      <h1 class="section-title" style="text-align: center;">Blog</h1>
    </header>

    <body>

    <section class="section wb">
     <<div class="container-fluid">
        <main class="tm-main">
            <!-- Search form -->
           
            <div class="row tm-row">
                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/blockchain-technology']" class="readmore">
                        <div class="tm-post-link-inner">
                            <img src="../assets/img/blog/blockchain-technology.jpg" alt="blockchain-technology" class="img-fluid">                            
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/blockchain-technology']" class="readmore">
                            What is Blockchain Technology?
                            </a>
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                        Blockchain technology is a structure in that store transactional details. Blockchain is growing list of records, called blocks and they are linked together called chain.
                    </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">09 September, 2021</span>
                    </div>
                 
                    
                </article>
                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/quantum-computing']" class="readmore">
                        <div class=" tm-post-link-inner">
                            <img src="../assets/img/blog/Quantum.jpg" style="height: 295px;" alt="Quantum" class="img-fluid">                            
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/quantum-computing']" class="readmore">
                                Quantum Computing
                            </a>
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                         Quantum computing is an emerging field that has significant potential, especially in the area of optimization problems.
                    </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">11 September, 2021</span>
                    </div>
                  
                </article>
                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/what-is-mobile-application']" class="readmore">
                        <div class="tm-post-link-inner">
                            <img src="../assets/img/blog/mobile-app.png" alt="mobile-app" class="img-fluid">
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/what-is-mobile-application']" class="readmore">
                                What is Mobile Application?
                            </a>
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                        Mobile application advancement is the arrangement of cycles and techniques engaged with composing programming for little, remote figuring gadgets, for example, cell phones and other hand-held gadgets. 
                    </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">07 October, 2021</span>
                    </div>
                 
                </article>
                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/ios-development']" class="readmore">
                        <div class="tm-post-link-inner">
                            <img src="../assets/img/blog/Ios_App.jpg" style="height: 335px;" alt="Ios App" class="img-fluid">
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/ios-development']" class="readmore">
                                What is iOS App Development?
                            </a>
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                        IOS application improvement is the most common way of making mobile applications for Apple equipment, including iPhone, iPad and iPod Touch. </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">12 January, 2022</span>
                    </div>
                 
                </article>
                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/web-app-development']" class="readmore">
                        <div class="tm-post-link-inner">
                            <img src="../assets/img/blog/WebApp.png" alt="Web Application" class="img-fluid">
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/web-app-development']" class="readmore">
                                Web Application Development
                            </a>
                          
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                        Web application development enables electronic tasks to perform and act in much the same way to a mobile application development.
                    </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">12 January, 2022</span>
                    </div>
                 
                </article>

                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/application-development-programming']" class="readmore">
                        <div class="tm-post-link-inner">
                            <img src="../assets/img/blog/App-Deve.jpeg" style="height: 270px;" alt="Application Development Programming" class="img-fluid">
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/application-development-programming']" class="readmore">
                            Application development programming
                            </a>
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                        Application development programming, or application for short, is programming that performs explicit errands for an end-client.
                    </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">15 January, 2022</span>
                    </div>
                 
                </article>
                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/database-development']" class="readmore">
                        <div class="tm-post-link-inner">
                            <img src="../assets/img/blog/DbMgt.jpg"  alt="Application Development Programming" class="img-fluid">
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/database-development']" class="readmore">
                                What is database development? 
                            </a>
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                        Database Developers are likewise named Database Programmers satisfying liabilities of creating supportable PC information bases for any organization.
                    </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">15 January, 2022</span>
                    </div>
                 
                </article>

                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/softwaredevelopment']" class="readmore">
                        <div class="tm-post-link-inner">
                            <img src="../assets/img/blog/SoftwareDevelopment.png" style="height: 296px;" alt="Application Development Programming" class="img-fluid">
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/softwaredevelopment']" class="readmore">
                                What is Software development? 
                            </a>
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                        Database Developers are likewise named Database Programmers satisfying liabilities of creating supportable PC information bases for any organization.
                    </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">15 January, 2022</span>
                    </div>
                 
                </article>

                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/CloudComputing']" class="readmore">
                        <div class="tm-post-link-inner">
                            <img src="../assets/img/blog/CloudComputing.jpg" style="height: 296px;" alt="Application Development Programming" class="img-fluid">
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/CloudComputing']" class="readmore">
                                Cloud computing 
                            </a>
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                        Cloud computing is a well-known choice for individuals and organizations for various reasons including cost investment funds, expanded usefulness, speed and productivity, execution, and security.
                    </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">25 January, 2022</span>
                    </div>
                 
                </article>

                <article class="col-12 col-md-6 tm-post">
                    <hr class="tm-hr-primary">
                    <a [routerLink]="['/CustomBuildSoftwareDevelopment']" class="readmore">
                        <div class="tm-post-link-inner">
                            <img src="../assets/img/blog/CustomBuild.jpg" style="height: 296px;" alt="Application Development Programming" class="img-fluid">
                        </div>
                        <h2 class="tm-pt-30 tm-color-primary tm-post-title">
                            <a [routerLink]="['/CustomBuildSoftwareDevelopment']" class="readmore">
                                Custom programming development
                            </a>
                        </h2>
                    </a>                    
                    <p class="tm-pt-30" style="text-align: justify;">
                        Custom programming development is the planning of programming applications for a particular client or gathering of clients inside an association.
                    </p>
                    <div class="d-flex justify-content-between tm-pt-45">
                        <span class="tm-color-primary"></span>
                        <span class="tm-color-primary">25 January, 2022</span>
                    </div>
                 
                </article>


            </div>
         
        </main>
    </div>
    </section>

 
    </body>

  </div>
</section><!-- #portfolio -->